import { useNavigate } from 'react-router-dom';

import { NavBar } from '@components/NavBar';
import { ENERGY_TARIFF } from '@constants/formNames';
import { paths } from '@constants/paths';
import { BundleBasketFragment } from '@generated/gql/graphql';

import { EnergyTariffFormBase } from './EnergyTariffFormBase';
import { useEnergyTracking } from './hooks/useEnergyTracking';

/**
 * Signup journey energy tariff form.
 */
const EnergyTariffForm = () => {
  const navigate = useNavigate();
  const {
    trackEnergyAddedToBasket,
    trackEvLinkClicked,
    trackEvBannerDisplayed,
    trackSmartMeterBannerDisplayed,
    trackFaqLinkClicked,
    trackFaqHeaderDisplayed,
  } = useEnergyTracking();

  const handleSubmitSuccess = (basket: Nullable<BundleBasketFragment>) => {
    navigate(paths.bundle);
    trackEnergyAddedToBasket(basket);
  };

  return (
    <EnergyTariffFormBase
      persistKey={ENERGY_TARIFF}
      enableFormSync
      evBanner={{
        onBannerDisplayed: trackEvBannerDisplayed,
        onLinkClick: trackEvLinkClicked,
      }}
      smartMeterBanner={{
        onBannerDisplayed: trackSmartMeterBannerDisplayed,
      }}
      faq={{
        onFaqLinkClicked: trackFaqLinkClicked,
        onFaqHeaderDisplayed: trackFaqHeaderDisplayed,
      }}
      onSubmitSuccess={handleSubmitSuccess}
      onEditDetails={() => navigate(paths.energyDetails)}
      remove={{ onSuccess: () => navigate(paths.bundle) }}
      renderNavBar={({
        onSave,
        onRemoveClick,
        isSubmitting,
        hasSelectedQuote,
      }) => (
        <NavBar
          hasRemoveButton={hasSelectedQuote}
          nextLabel={hasSelectedQuote ? 'Save' : 'Add to bundle'}
          nextDisabled={isSubmitting}
          onNext={onSave}
          onRemove={onRemoveClick}
        />
      )}
    />
  );
};

export { EnergyTariffForm };
